var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForm = function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.466 28.051a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm1 5v-3h28v3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m50.74 59.755 1.56-1.347-.653-.757-.856.74-.715-.715-.707.707z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.466 56.051a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-30a1 1 0 0 1-1-1zm2 1v3h28v-3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.533 48.622a1 1 0 0 1 .998-1.001l23-.036a1 1 0 1 1 .003 2l-23 .036a1 1 0 0 1-1.001-.999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.397 52.051a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-1-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.533 40.622a1 1 0 0 1 .998-1.001l23-.036a1 1 0 1 1 .003 2l-23 .036a1 1 0 0 1-1.001-.999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.397 44.051a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-1-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21 16.96a1 1 0 0 1 1-1h36a1 1 0 1 1 0 2H22a1 1 0 0 1-1-1M22 19.96a1 1 0 1 0 0 2h36a1 1 0 0 0 0-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15 10.133a1 1 0 0 0-1 1v58a1 1 0 0 0 1 1h50a1 1 0 0 0 1-1v-58a1 1 0 0 0-1-1zm1 58v-56h48v56z",
    clipRule: "evenodd"
  })));
};
export default SvgForm;